var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectricalServicesBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FC2847EA-FD1D-483C-B81C-EAD46734DB55@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCC6-Make-a-reservation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-reservations-card_Park-Place",
    transform: "translate(-911.000000, -497.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "electrical_services_black_24dp-copy",
    transform: "translate(911.000000, 497.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.666667)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,6.66666667 C12,6.3 11.7,6 11.3333333,6 L10,6 L10,7.33333333 L11.3333333,7.33333333 C11.7,7.33333333 12,7.03333333 12,6.66666667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333333,8.66666667 L10,8.66666667 L10,10 L11.3333333,10 C11.7,10 12,9.7 12,9.33333333 C12,8.96666667 11.7,8.66666667 11.3333333,8.66666667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66666667,5.33333333 L7.33333333,5.33333333 C6.6,5.33333333 6,5.93333333 6,6.66666667 L5.33333333,6.66666667 C4.96666667,6.66666667 4.66666667,6.96666667 4.66666667,7.33333333 L4.66666667,8.66666667 C4.66666667,9.03333333 4.96666667,9.33333333 5.33333333,9.33333333 L6,9.33333333 C6,10.0666667 6.6,10.6666667 7.33333333,10.6666667 L8.66666667,10.6666667 C9.03333333,10.6666667 9.33333333,10.3666667 9.33333333,10 L9.33333333,6 C9.33333333,5.63333333 9.03333333,5.33333333 8.66666667,5.33333333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33333333,6 C1.33333333,5.26666667 1.93333333,4.66666667 2.66666667,4.66666667 L3.66666667,4.66666667 C4.95333333,4.66666667 6,3.62 6,2.33333333 C6,1.04666667 4.95333333,0 3.66666667,0 L1.33333333,0 C0.966666667,0 0.666666667,0.3 0.666666667,0.666666667 C0.666666667,1.03333333 0.966666667,1.33333333 1.33333333,1.33333333 L3.66666667,1.33333333 C4.22,1.33333333 4.66666667,1.78 4.66666667,2.33333333 C4.66666667,2.88666667 4.22,3.33333333 3.66666667,3.33333333 L2.66666667,3.33333333 C1.19333333,3.33333333 0,4.52666667 0,6 C0,7.47333333 1.19333333,8.66666667 2.66666667,8.66666667 L4,8.66666667 L4,7.33333333 L2.66666667,7.33333333 C1.93333333,7.33333333 1.33333333,6.73333333 1.33333333,6 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalServicesBlack24Dp);
export default __webpack_public_path__ + "static/media/electrical_services_black_24dp.a7592401917b9bb2fcd40a0027f17882.svg";
export { ForwardRef as ReactComponent };